import * as React from 'react';
import { IconProps } from '../../dto/Interfaces/IIconProps';
import { useTheme } from '@mui/material';

const WeiboIcon: React.FC<IconProps> = ({ size, style, color }) => {
  const theme = useTheme();
  return (
    <svg xmlns="http://www.w3.org/2000/svg" style={style} width={size ?? '24'} height={size ?? '24'} viewBox="0 -9.6 735.8 596.7" data-testid="weibo-icon">
      <path
        d="m53.3 403.7c0 84.4 109.9 152.8 245.4 152.8s245.4-68.4 245.4-152.8-109.9-152.8-245.4-152.8-245.4 68.4-245.4 152.8"
        fill={color === '#fff' ? theme.palette.primary.main : '#fff'}
      />
      <path
        d="m304.5 544.1c-120 11.9-223.6-42.4-231.4-121.1-7.8-78.8 83.2-152.2 203.1-164.1 120-11.9 223.6 42.4 231.3 121.1 7.9 78.8-83.1 152.3-203 164.1m239.9-261.5c-10.2-3.1-17.2-5.1-11.9-18.5 11.6-29.1 12.8-54.2.2-72.2-23.5-33.6-87.9-31.8-161.7-.9 0 0-23.2 10.1-17.2-8.2 11.3-36.5 9.6-67-8-84.7-40-40.1-146.5 1.5-237.8 92.8-68.3 68.3-108 140.8-108 203.5 0 119.8 153.7 192.7 304 192.7 197.1 0 328.2-114.5 328.2-205.4.1-55-46.2-86.2-87.8-99.1"
        fill={color ?? '#e6162d'}
      />
      <path
        d="m675.3 63.3c-47.6-52.8-117.8-72.9-182.6-59.1-15 3.2-24.5 18-21.3 32.9 3.2 15 17.9 24.5 32.9 21.3 46.1-9.8 96 4.5 129.8 42s43 88.6 28.5 133.4c-4.7 14.6 3.3 30.2 17.9 34.9s30.2-3.3 34.9-17.8v-.1c20.4-62.9 7.5-134.8-40.1-187.5"
        fill={color ?? '#f93'}
      />
      <path
        d="m602.2 129.3c-23.2-25.7-57.4-35.5-88.9-28.7-12.9 2.7-21.1 15.5-18.4 28.4 2.8 12.9 15.5 21.1 28.3 18.3 15.4-3.3 32.2 1.5 43.5 14 11.3 12.6 14.4 29.7 9.5 44.7-4 12.5 2.8 26 15.4 30.1 12.6 4 26-2.8 30.1-15.4 9.9-30.7 3.7-65.7-19.5-91.4"
        fill={color ?? '#f93'}
      />
      <path
        d="m311.1 401.5c-4.2 7.2-13.5 10.6-20.7 7.6-7.2-2.9-9.4-11-5.3-18 4.2-7 13.1-10.4 20.2-7.6 7.2 2.6 9.8 10.7 5.8 18m-38.3 49c-11.6 18.5-36.5 26.6-55.2 18.1-18.4-8.4-23.9-29.9-12.3-48 11.5-18 35.5-26 54.1-18.2 18.8 8.1 24.8 29.4 13.4 48.1m43.6-131c-57.1-14.9-121.6 13.6-146.4 63.9-25.3 51.3-.8 108.3 56.8 126.9 59.8 19.3 130.2-10.3 154.7-65.6 24.2-54.2-6-109.9-65.1-125.2"
        fill={color ?? '#000'}
      />
    </svg>
  );
};

export default WeiboIcon;
